import styled from "styled-components"
import checkmarkDark from '../../images/checkmark-dark.svg'
import checkmarkLight from '../../images/checkmark-light.svg'

const Checkmark = styled.span`
	background-image: url(${props => props.light ? checkmarkLight : checkmarkDark});
	width: 20px;
  height: 20px;
  display: inline-block;
  background-size: 40px 40px;
  background-position: center center;
  position: relative;
  top: 4px;
`

export default Checkmark